export enum OfferFinalizationTypeEnum {
  CallBack = 'callback',
  Online = 'online',
  Redirect = 'redirect',
}
